import { render, staticRenderFns } from "./testTab.vue?vue&type=template&id=3f4e9580&scoped=true&"
import script from "./testTab.vue?vue&type=script&lang=js&"
export * from "./testTab.vue?vue&type=script&lang=js&"
import style0 from "./testTab.vue?vue&type=style&index=0&id=3f4e9580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e9580",
  null
  
)

export default component.exports